export const PERIODS = {
  MAIN: 'main',
  COMPARE: 'compare'
};
